import { useQuery } from '@tanstack/react-query'
import { pricesApi } from '@/api/endpoints/prices'

export function usePrices(sku: string) {
  return useQuery({
    queryKey: ['products', sku, 'prices'],
    queryFn: () => pricesApi.list(sku),
    select: (data) => data.items,
    enabled: !!sku,
  })
}
